<template>
    <div>
        <div class="relate-model-FormList">
            <div class="btns" style="height:38px;line-height:38px;">
                <div class="text-desc desc-content2">
                    <el-row style="float:right;margin-bottom: 2px">
                        <!-- <el-button v-show="isModelForm && formBtnAuth.isShowAdd" icon="el-icon-circle-plus-outline" type="primary" title="复制历史数据"  @click="reloadHisData()">复制历史</el-button> -->
                        <el-checkbox class="checkBox-style" v-if="isCanShowSummery" v-model="isShowSummary" @change="handleShowSummery"><el-tag size="mini">合计</el-tag></el-checkbox>
                        <el-button icon="el-icon-document-add" type="primary" title="生成绩效数据"
                            @click="createAchievementsData()" v-if="showAchievementsData && !viewData">生成绩效数据</el-button>
                        <el-button v-if="relateModelQuote && !viewData" icon="el-icon-connection" type="primary" title="引用数据"
                            @click="quoteFormData()">引用数据</el-button>
                        <el-button icon="el-icon-delete-solid" type="danger" title="移除" @click="removeQuoteFormData()"
                            v-if="relateModelQuote && !viewData">移除引用</el-button>
                        <el-button v-show="isModelForm && formBtnAuth.isShowAdd && !viewData" icon="el-icon-circle-plus-outline"
                            type="primary" title="新增" @click="addFormData()">新增</el-button>
                        <el-button v-show="isModelForm && formBtnAuth.isShowDelete && !viewData" icon="el-icon-delete" type="danger"
                            title="删除" @click="handleModelFormBatchDelete()">删除</el-button>
                        <el-button v-show="isCalcul" icon="iconfont icon-other-daochu" type="primary"
                            title="导出" @click="dataCurrentExport()">导出</el-button>
                    </el-row>
                </div>
            </div>
            <div class="model-content" style="width:100%;">
                <div class="content-left">
                    <!-- @rowDblclick="handelSelectRow" 原来设置的双击只读效果 -->
                    <DynamicTable ref="dynamicTable" :showSummary="showSummary" :tableColumns="tableColumns"
                        :fieldsList="fieldsList" :subformTableColumns="subformTableColumns" :tableData="pageData"
                        :isLoading="tableLoading" :isShowCheckbox="isModelForm" :isSortable="true" :isColumnDrop="true"
                        :isSubform="isSubform" :isShowPageSizes="true" :isShowOverflowTooltip="isShowOverflowTooltip"
                        :tableHeight="tableHeight" :autoHeight="true" :isShowProcessInfo="isShowProcessInfo"
                        :isViewApprovalInfo="isViewApprovalInfo" :key="time" :approvalList="approvalList"
                        :minuend="minuend" :hiddenPage="true" :pager="page" @filterChange="chooseApprovalStatusField"
                        @rowClick="handelSelectRow" @rowDblclick="handelDbSelectRow"
                        @changePageSize="queryFormDataByPageSize" @changePage="queryFormData"
                        @searchOrderby="searchOrderby" @selectionChange="selectMore">
                    </DynamicTable>
                </div>
                <el-dialog width="95%" top="1vh" class="popEditModelDetailPop" :fullscreen=true :visible.sync="active"
                    append-to-body @close="hideDialog">
                    <RelateModelDetail v-if="isShowModelDetail" :isShowForm="isShowForm" :isReturnToNav="isReturnToNav"
                        ref="relateModelInstance" :isRead="isRead" :formInfo="formInfo" :parentFormInfo="parentFormInfo"
                        :parentFormData="parentFormData" :isShowSaveBtn="false" :ifShowBtn="ifShowBtn"
                        :approvalStatus="approvalStatus" @cancelClick="hideDialog" @modelComplete="handleModelComplete"
                        @setIsShowForm="setIsShowForm" />
                </el-dialog>
                <el-dialog width="95%" top="1vh" height="80vh" class="popQuoteFormList" :visible.sync="popQuoteFormList"
                    v-if="popQuoteFormList" append-to-body>
                    <div>
                        <div>
                            <el-button class="btn-style" icon="el-icon-search" type="primary" title="筛选条件"
                                @click="handleFilterCondition()">筛选</el-button>
                        </div>
                        <DynamicTable ref="popQuoteDynamicTable" :showSummary="showSummary" :pager="popQuotePage"
                            :tableColumns="popQuoteTableColumns" :fieldsList="popQuoteFieldsList"
                            :subformTableColumns="subformTableColumns" :tableData="popQuotePageData"
                            :isLoading="tableLoading" :isShowCheckbox="isModelForm" :isSortable="true"
                            :isColumnDrop="true" :isSubform="isSubform" :isShowPageSizes="true" 
                            :isShowOverflowTooltip="isShowOverflowTooltip" :tableHeight="tableHeight" :autoHeight="true"
                            :isShowProcessInfo="isShowProcessInfo" :isViewApprovalInfo="isViewApprovalInfo" :key="timer"
                            :approvalList="approvalList" :minuend="minuend" @changePageSize="popQuoteFormDataByPageSize"
                            @changePage="popQuoteFormData" @selectionChange="popQuoteSelectMore">
                        </DynamicTable>
                    </div>
                    <div style="text-align:right;">
                        <el-button type="primary" @click="addRefFormData">确定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="设置查询条件" append-to-body top="4vh" custom-class="search-box" v-if="isShowSearchConditon"
                    :visible.sync="isShowSearchConditon">
                    <SearchCondition :key="searchLoaderTime" v-if="isShowSearchConditon" ref="searchConditon"
                        :conditionFields="conditionFields" :isShowLeftModel="false"
                        @chooseRefSearchConditon="chooseRefSearchConditon" />
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="isShowSearchConditon = false">取 消</el-button>
                        <el-button @click="resetSearchConditon">重置</el-button>
                        <el-button type="primary" @click="chooseRefSearchConditon">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import ReportRelateTree from '@/components/ReportRelateTree';
import RelateModelDetail from './RelateModelDetail';
import ExcelDataImport from './ExcelDataImport';
import SelectMultiple from '@/components/SelectMultiple';
import SearchCondition from '@/components/SearchCondition';
import SideLeftTree from '@/components/SideLeftTree';
import VueOrgTree from '@/components/VueOrgTree';
import {
    API_EXPORT_MODEL_FORM_EXCEL,
    API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID,
    CONST_PERMISSION_BUSINESS_DELETE_MODEL_RECORD_BTN,
    CONST_PERMISSION_BUSINESS_MODIFIED_MODEL_RECORD_BTN,
    CONST_PERMISSION_BUSINESS_EXPORT_BUSINESS_FORM_DATA_BTN,
    CONST_PERMISSION_BUSINESS_IMPORT_BUSINESS_FORM_DATA_BTN,
    CONST_PERMISSION_BUSINESS_SYN_PROCESS_DATA_BTN,
    CONST_PERMISSION_BUSINESS_ADD_MODEL_RECORD_BTN,
    CONST_PERMISSION_BUSINESS_APPLICATION_CONFIG
} from '@/common/constants';
import { isEmpty, cloneDeep } from 'lodash';
import {
    isTeamWorkModelFirstTaskForm, getTeamWorkModelInstanceId, getModelFormById, getApprovalInstanceDetail, getFormConfigs, getModelFormReportList,
    getModelFormInstanceById, saveAppModelForm, delModelFormInstance, updRPARuleData, getFormulaSearchList,
    syncProcessFormData, getFormFieldListByIds, getExcelDataExportId, updateUserFormViewField, getModelFormReportOrgTree, getModelFormByDraft
} from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';
import { getUUID } from '@/utils/grocer';
import { mapGetters } from 'vuex';

export default {
    mixins: [mixinsNav],
    components: {
        ReportRelateTree,
        RelateModelDetail,
        ExcelDataImport,
        SelectMultiple,
        SearchCondition,
        SideLeftTree,
        VueOrgTree
    },
    data () {
        return {
            formBtnAuth: {// 表单按钮权限
                isShowAdd: true, // 新增
                isShowDelete: true // 删除
            },
            mainLinkFieldList: [], // 主表的关联字段List
            addPageData: [], // 前段暂存的未保存数据
            treeOrgData: {},
            loadTimerReport: '',
            isShowOrgTreeDialog: false,
            formDataId: '', // 单条数据的导出
            hasLinkField: false, // 是否有关联字段
            loadTimer: '',
            isShowReportRelateTree: false,
            isShowSummary: false,
            isCanShowSummery: false, // 是否可以显示合计行
            isFilterDuplicateData: false,
            isCollapse: true,
            leftTitleFlag: true,
            needSumData: false, // 是否将汇总值一起导出
            showSummary: false, // 是否要显示求和
            hideOverflowTooltip: false,
            isViewProcessInfo: false, // 是否显示关联流程明细
            isViewApprovalInfo: false, // 是否显示审批状态和审批详情
            isShowProcessInfo: false, // 是否显示流程
            isShowOverflowTooltip: true,
            unDelNums: '', // 不可删除的数据序号，逗号隔开
            isHasUNDel: false,
            moreIds: '', // 多选IDS字符串
            popQuoteMoreIds: '',
            templateInfo: {
                id: '',
                templateName: '',
                busiType: '',
                busiTypeName: '',
                remarks: '',
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                templateState: null,
                forms: [],
                users: [],
                dataOperate: {
                    dataSource: 2,
                    forms: []
                },
                parentApprovalId: '',
                mainApprovalId: ''
            },
            isRead: false,
            btnMode: 0, // 0申请-草稿 1审批
            selectedRowId: '',
            isInstance: false,
            instances: {
                id: '',
                formObj: {}
            },
            approvalInfo: {
                approvalRemarks: '',
                selectedCopyUserIds: '',
                selectedCopyUserNames: ''
            },
            approvalInstanceList: [],
            isShowApprovalPop: false,
            approvalTitle: '查看审批详情',
            tableHeight: this.fullScreen ? '560' : '520',
            isSubform: false, // 是否包含子表单
            isModelForm: true, // 是否模型表单
            tableLoading: false,
            isShowForm: false,
            idStr: '',
            printStr: '',
            isShowModelDetail: false,
            isShowExcelData: false,
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10000, // 每页条数
                totalPageNum: 1 // 总页数
            },
            popQuotePage: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 0, // 总页数
                pageSizes: [10, 20]
            },
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: ''
            },
            tableColumns: [],
            popQuoteTableColumns: [],
            fieldsList: [],
            popQuoteFieldsList: [],
            allTableColumns: [],
            subformTableColumns: [],
            pageData: [],
            popQuotePageData: [],
            active: false, // 是否显示数据编辑侧滑弹窗
            formInfo: {},
            downloadUrl: '',
            isShowFilterField: false,
            sourceOptions: [],
            oldSelectedModel: {},
            isRefreshSel: false,
            isRefreshCondition: false,
            isShowSearchConditon: false,
            conditionFields: [],
            isShowApprovalStatus: false,
            isApprovalForm: false,
            approvalList: [],
            isShowDown: false, // 是否单条数据显示下载按钮，默认false
            isInit: true,
            approvalStatusOptions: [{ id: '0', label: '草稿' }, { id: '1', label: '审批中' }, { id: '2', label: '通过' }, { id: '3', label: '驳回' }, { id: 'ALL_SELECT', label: 'ALL' }],
            permission: {
                deleteModelRecordBtn: [
                    CONST_PERMISSION_BUSINESS_DELETE_MODEL_RECORD_BTN
                ],
                modifiedModelRecordBtn: [
                    CONST_PERMISSION_BUSINESS_MODIFIED_MODEL_RECORD_BTN
                ],
                exportBusinessFormDataBtn: [
                    CONST_PERMISSION_BUSINESS_EXPORT_BUSINESS_FORM_DATA_BTN
                ],
                importBusinessFormDataBtn: [
                    CONST_PERMISSION_BUSINESS_IMPORT_BUSINESS_FORM_DATA_BTN
                ],
                synProcessDataBtn: [
                    CONST_PERMISSION_BUSINESS_SYN_PROCESS_DATA_BTN
                ],
                addModelRecordBtn: [
                    CONST_PERMISSION_BUSINESS_ADD_MODEL_RECORD_BTN
                ],
                isShowApplicationConfig: [
                    CONST_PERMISSION_BUSINESS_APPLICATION_CONFIG
                ]
            },
            time: new Date().getTime(),
            fieldTime: '',
            destoryTable: true,
            relateModelQuote: false,
            popQuoteFormList: false,
            popQuoteModelCache: {},
            timer: '',
            searchLoaderTime: '',
            cacheSearchField: '',
            cacheDeleteDataIds: '',
            showAchievementsData: false,
            formulaSearchConditionFields: []
        };
    },
    props: {
        selectedModel: {
            type: Object
        },
        taskInfo: {
            type: Object
        },
        // formBtnAuth: {// 表单按钮权限
        //     type: Object,
        //     default: function () {
        //         return {
        //             isShowView: true, // 查看
        //             isShowAdd: true, // 新增
        //             isShowEdit: true, // 修改
        //             isShowDelete: true, // 删除
        //             isShowImport: true, // 导入
        //             isShowExport: true, // 导出
        //             isShowSyn: true// 同步流程数据
        //         };
        //     }
        // },
        fullScreen: {
            type: Boolean,
            default: false
        },
        isNewPage: {
            type: Boolean,
            default: false
        },
        isReturnToNav: {// 为发起审批成功后，判断来自于新交互模式还是旧模式，默认旧模式
            type: Boolean,
            default: false
        },
        fromReport: {
            type: Boolean,
            default: false
        },
        isCollapseForInit: {
            type: Boolean,
            default: true
        },
        showLeft: {
            type: Boolean,
            default: true
        },
        minuend: {
            type: Number,
            default: 180
        },
        tempFormData: {// 待保存的关联表数据
            type: Array,
            default: []
        },
        parentFormInfo: {
            type: Object
        },
        parentFormData: {
            type: Array,
            default: []
        },
        ifShowBtn: {
            type: Boolean,
            default: true
        },
        approvalStatus: {
            type: Number
        },
        viewData: {
            type: Boolean,
            default: false
        },
        isCalcul: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    created () {
        // console.log(this.approvalStatus);
        // console.log(this.parentFormInfo);
        // console.log(this.parentFormData);
        // console.log(this.tempFormData);
        // console.log(this.userInfo);
        if (this.parentFormInfo) {
            let fieldsList = [];
            if (this.parentFormInfo.hasOwnProperty('fieldsList')) { // 来自任务或审批流
                fieldsList = this.parentFormInfo.fieldsList;
                this.relateModelQuote = this.parentFormInfo.relateModelQuote;
            } else { // 来自应用表单
                fieldsList = this.parentFormInfo.formObj.structure[0].fieldsList;
                this.relateModelQuote = this.parentFormInfo.formObj.structure[0].relateModelQuote;
            }
            fieldsList.forEach(element => {
                // if (element.type === 'link') {
                this.mainLinkFieldList.push(element);
                // }
            });
        }
        this.isCollapse = this.isCollapseForInit;// 初始化左侧收起展开
        if (this.isNewPage) { // 新页面引用
            this.time = new Date().getTime();
            // this._initFormData();
        }
        // 初始化表单权限
        // this.setFormAuth();
        if ((this.userInfo.tenantId === '2a19bf2841304dd5b4ef566ed536ecf7') && (this.selectedModel.formId === '14f9bcb3c4c44cb1853e0e864f0d7e8f' ||
            this.selectedModel.formId === '9ee70152560a4dce9da723777ddfa560' || this.selectedModel.formId === '822a1c99d5164875aa5257ee6fd88150')
        ) { // 中兴华咨定绩效制化需求
            if (this.parentFormInfo.formId === 'e75e01ad23b343809ac16bf69302f24d') {
                this.showAchievementsData = false;
                this.relateModelQuote = true;
            } else {
                this.showAchievementsData = true;
            }
        } else if ((this.userInfo.tenantId === '2a19bf2841304dd5b4ef566ed536ecf7') && this.parentFormInfo.formId === 'dc36ba40d7664d09aa110e256e424a11') { // 档案交接，可以被多次引用
            this.relateModelQuote = true;
        }
    },
    watch: {
        'tempFormData' (newVal, oldVal) {
        }
    },
    methods: {
        setFormAuth () {
            // console.log(1111);
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            let userInfo = JSON.parse(currentUserStr);
            let userFormAuth = userInfo.modelUserAuthMap[this.selectedModel.formId];
            this.initFormAuth(true);
            if (!isEmpty(userFormAuth) && !isEmpty(userFormAuth.modelAuthList)) {
                this.initFormAuth(false);
                let authArr = userFormAuth.modelAuthList.split(',');
                for (let i = 0; i < authArr.length; i++) {
                    if (authArr[i] === '1') {
                        this.formBtnAuth.isShowAdd = true;
                    } else if (authArr[i] === '3') {
                        this.formBtnAuth.isShowDelete = true;
                    }
                }
            }
        },
        initFormAuth (flg) {
            this.formBtnAuth.isShowAdd = flg; // 新增
            this.formBtnAuth.isShowDelete = flg; // 删除
        },
        handleConfigApplication () {
            let url = '/application/model-config';
            window.sessionStorage.setItem('currentOpenUrl', url);// 路由定位
            let param = { modelId: this.selectedModel.id, appId: this.selectedModel.fappId, appName: this.selectedModel.fappName };
            window.sessionStorage.setItem('openUrlParam', JSON.stringify(param));// 传递的参数
            window.sessionStorage.setItem('locationDesignAppId', this.selectedModel.fappId);// 进入应用设计时定位打开对应应用
            this.$router.push({ name: 'model-config', path: url, query: param });
            // if (this.isNewPage) {
            //     let url = '/application/model-config';
            //     sessionStorage.setItem('currentOpenUrl', url);// 路由定位
            //     let param = {modelId: this.selectedModel.id, appId: this.selectedModel.fappId, appName: this.selectedModel.fappName};
            //     sessionStorage.setItem('openUrlParam', JSON.stringify(param));// 传递的参数
            //     sessionStorage.setItem('locationDesignAppId', this.selectedModel.fappId);// 进入应用设计时定位打开对应应用
            //     this.$router.push({ name: 'model-config', path: url, query: param });
            // } else {
            //     this.destoryTable = false;
            //     sessionStorage.setItem('locationDesignAppId', this.selectedModel.appId);// 进入应用设计时定位打开对应应用
            //     this.navConfigApplication(this.selectedModel.fappId, this.selectedModel.fappName, this.selectedModel.id);
            // }
        },
        async reloadHisData (formData) {
            // 是协同办公首任务
            let retMap = await isTeamWorkModelFirstTaskForm({ formId: this.selectedModel.mainFormId, processInstanceId: this.taskInfo.processInstanceId, taskDefinitionKey: this.taskInfo.taskDefinitionKey });
            if (retMap && retMap.isTeamWorkFirstTask) { // 是协同办公表单的首任务节点
                this.tableLoading = true;
                let param = cloneDeep(this.searchParams);
                if (retMap.lastDeletedModelInstanceId) { // 驳回已删除的那一条最新的主表数据ID
                    param.mainFormDataId = retMap.lastDeletedModelInstanceId;
                }
                if (!isEmpty(formData.data)) { // 假如主表主键带出时已经有数据了
                    param.mainFormDataId = this.searchParams.mainFormDataId;
                    this.selectedModel.mainFormDataId = this.searchParams.mainFormDataId;
                } else {
                    param.reloadHisData = true; // 加载历史数据
                }
                // console.log(this.selectedModel);
                let retData = await getModelFormReportList(Object.assign({}, {
                    currentPage: 0,
                    pageSize: 50
                }, param));
                // 关联了主表的关联字段
                let linkFields = retData.otherData.linkFieldList;
                let fieldsList = retData.otherData.fieldsList;
                let attributes = {};
                if (fieldsList) {
                    for (let i = 0; i < fieldsList.length; i++) {
                        let field = fieldsList[i];
                        attributes[field.id] = field.type;
                    }
                }
                if (retData.data) {
                    // this.pageData = [];
                    // console.log(this.selectedModel.formId);
                    // console.log(this.pageData);
                    let isFilter = false;// 是否重复数据需要过滤
                    retData.data.forEach(item => {
                        isFilter = false;
                        let jsonObj = JSON.parse(item);
                        // 过滤重复id
                        for (let index = 0; index < this.tempFormData.length; index++) {
                            let tempData = this.tempFormData[index];
                            if (jsonObj.id === this.tempFormData[index].forms[0].values.subRelateFormId) {
                                isFilter = true;
                                break;
                            } else if (tempData.formId === this.selectedModel.formId && tempData.forms[0].values.id === jsonObj.id) { // 过滤掉重复的数据
                                isFilter = true;
                                break;
                            }
                        }
                        if (isFilter) {
                            return true;
                        }
                        let formData = {
                            forms: [
                                {
                                    ext1: 0,
                                    colSpan: 1,
                                    formId: this.selectedModel.formId,
                                    values: {},
                                    attributes: cloneDeep(attributes)
                                }
                            ]
                        };
                        formData.modelId = this.selectedModel.id;
                        formData.formId = this.selectedModel.formId;
                        let uuid = getUUID(16, 16);
                        jsonObj.subRelateFormId = cloneDeep(jsonObj.id);
                        jsonObj.id = uuid;
                        jsonObj.rowspan = 1;
                        jsonObj.num = 1;
                        jsonObj.isOldData = false;
                        jsonObj.modelId = this.selectedModel.id;
                        jsonObj.formId = this.selectedModel.formId;
                        // 找到关联字段，一般只有一个，并清空值
                        if (linkFields) {
                            for (let i = 0; i < linkFields.length; i++) {
                                let linkFieldId = linkFields[i].id;
                                delete jsonObj[linkFieldId];
                                delete jsonObj[linkFieldId + '-view'];
                                delete jsonObj[linkFieldId + '-link'];
                            }
                        }
                        formData.forms[0].values = jsonObj;
                        this.tempFormData.push(formData); // 主数据保存后再保存的关联表单数据
                        this.pageData.unshift(jsonObj); // 用于显示到列表中
                        this.page.totalPageNum = this.page.totalPageNum + 1;
                    });
                }
                this.tableLoading = false;
            }
        },
        async _initFormData () {
            this.renderFormList(this.selectedModel);
        },
        queryFormData ({ currentPage }, type) {
            this.isInit = false;
            this.page.currentPage = currentPage;
            this.renderFormList(this.selectedModel, type);
        },
        popQuoteQueryFormData () {
            // console.log(this.selectedModel);
        },
        queryFormDataByPageSize ({ pageSize }) {
            this.isInit = false;
            this.page.pageSize = pageSize;
            this.renderFormList(this.selectedModel);
        },
        searchOrderby (searchItem) {
            this.searchParams.searchCondition = [];
            this.searchParams.searchCondition.push(searchItem);
            this.queryFormData(1);
        },

        async getFormulaSearchList (model) {
            if (model.calculateFieldId) {
                this.formulaSearchConditionFields = [];
                let param = {fieldId: model.calculateFieldId};
                let res = await getFormulaSearchList(param);
                let pkbm = null;// 个性化查询，针对部门余额表的管理费、职业风险金这两个值的小眼睛查看 20240521
                let pkbmId = null;// 总部50739F50    分公司44441DE9   分公司挂账总部81EAF91C
                if (res && res.length > 0) {
                    if (this.parentFormData && this.parentFormData.length > 0) {
                        let mainFormData = this.parentFormData[0].values;
                        if (mainFormData) {
                            pkbm = mainFormData['d09c611ea6624bb5bba0e9b683e8e7b3-view'];
                            pkbmId = mainFormData['d09c611ea6624bb5bba0e9b683e8e7b3'];
                        }
                    }
                    let formulaSearchArray = cloneDeep(res);
                    let conditions = [];
                    let conditionsMap = new Map();
                    for (let i = 0; i < formulaSearchArray.length; i++) {
                        let formulaSearchCondition = formulaSearchArray[i];
                        if (formulaSearchCondition.formId === model.formId) {
                            // this.formulaSearchConditionFields = JSON.parse(formulaSearchCondition.fieldCondition);
                            let currentCoditions = JSON.parse(formulaSearchCondition.fieldCondition);
                            let filterConditions = [];
                            for (let j = 0; j < currentCoditions.length; j++) {
                                let condition = currentCoditions[j];
                                if ((!isEmpty(condition.conditionValue) || (!isEmpty(condition.conditionValueSdt) && !isEmpty(condition.conditionValueEdt))) && (typeof condition.operateType === 'number' && !isNaN(condition.operateType))) {
                                    // 1.针对部门余额表的管理费、职业风险金这两个值的小眼睛查看  总部、分公司 这里按总部和分公司过滤掉多余的条件
                                    // 2.过滤掉总部分公司的条件  余额表字段为：职业风险金(收入)  1feceb4e5206442a9a573521c88f8b52    管理费(收入) 726e6cb3dc074790a706e377f8bb8224   营业收入 a4d175acaa814340a7cd1acacfc3f29b
                                    //  是否分公司开票3139fe5e76264781901966a693a492af              业务执行模式20a524a6afa44506abebd90df867eeb6
                                    if (condition.id === '3139fe5e76264781901966a693a492af' && (condition.conditionValueView != pkbm || model.calculateFieldId === '1feceb4e5206442a9a573521c88f8b52' || model.calculateFieldId === '726e6cb3dc074790a706e377f8bb8224')) {
                                        continue;
                                    } else if (condition.id === '20a524a6afa44506abebd90df867eeb6' && model.calculateFieldId === 'a4d175acaa814340a7cd1acacfc3f29b') {
                                        if ((pkbmId === '81EAF91C' && condition.conditionValue.length === 1) || (pkbmId !== '81EAF91C' && condition.conditionValue.length > 1)) {
                                        } else {
                                            continue;
                                        }
                                    }
                                    if (!conditionsMap.has(condition.id)) {
                                        conditionsMap.set(condition.id, condition);
                                        filterConditions.push(cloneDeep(condition));
                                    }
                                }
                            }
                            conditions = conditions.concat(filterConditions);
                        }
                    }
                    conditionsMap = null;
                    this.formulaSearchConditionFields = conditions;
                }
            }
        },

        async renderFormList (model, isInitSearch, isReStartApproval) {
            // console.log(model);
            await this.getFormulaSearchList(model);// 增加公式字段的查询条件
            this.destoryTable = true;
            if (this.oldSelectedModel && this.oldSelectedModel.id !== model.id) {
                this.oldSelectedModel = model;
                this.searchParams.selectedFields = '';
                this.isRefreshSel = true;
                this.isRefreshCondition = true;
                this.searchParams.searchCondition = [];
                this.searchParams.selectedApprovalStatus = '';// 初始化审批状态查询条件
                // this.isSubform=false;
                this.sourceOptions = [];
            }
            this.selectedModel = model;
            if (this.selectedModel.modelType > 1) {
                this.isModelForm = false;
            } else {
                this.isModelForm = true;
            }
            this.tableColumns = [];
            this.fieldsList = [];
            this.isSubform = false;
            this.tableLoading = true;
            this.searchParams.modelId = model.id;
            this.searchParams.formId = model.formId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = this.isFilterDuplicateData;
            // 主表的formid和当前主表的数据id
            this.searchParams.mainFormId = model.mainFormId;
            this.searchParams.mainFormDataId = model.mainFormDataId;
            // 任务节点部门设置子表单数据权限
            this.searchParams.processInstanceIdAuth = model.processInstanceIdAuth ? model.processInstanceIdAuth : null;
            this.searchParams.taskIdAuth = model.taskIdAuth ? model.taskIdAuth : null;
            if (this.taskInfo) {
                // console.log('前mainFormDataId: ' + this.searchParams.mainFormDataId);
                // 任务中查看关联表单（协同办公）
                let modelInstanceIdMap = await getTeamWorkModelInstanceId({ formId: model.mainFormId, processInstanceId: this.taskInfo.processInstanceId, taskInstanceId: this.taskInfo.id, taskDefinitionKey: this.taskInfo.taskDefinitionKey });
                if (modelInstanceIdMap && modelInstanceIdMap.modelInstanceId) {
                    if (this.selectedModel.formId === '14f9bcb3c4c44cb1853e0e864f0d7e8f' || this.selectedModel.formId === '822a1c99d5164875aa5257ee6fd88150' || this.selectedModel.formId === '9ee70152560a4dce9da723777ddfa560' || this.selectedModel.formId === 'e75e01ad23b343809ac16bf69302f24d') {
                        // 中兴华咨绩效不走这个逻辑
                    } else {
                        this.searchParams.mainFormDataId = modelInstanceIdMap.modelInstanceId;
                    }
                }
                // this.searchParams.mainFormDataId = '8324c20d94804c489de4d93cc6868fc9';
                // console.log('后' + this.searchParams.mainFormDataId);
            }
            this.searchParams.isFormulaSearch = null;
            if (isEmpty(!this.formulaSearchConditionFields)) { // 增加公式字段查询的逻辑
                this.searchParams.searchCondition = this.searchParams.searchCondition.concat(this.formulaSearchConditionFields);
                this.searchParams.isFormulaSearch = true;
            }
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            if (formData && formData.otherData && formData.otherData.searchCondition) {
                this.conditionFields = JSON.parse(formData.otherData.searchCondition);
            }
            // this.pageData = [];
            if (formData.data) {
                if (this.tempFormData && this.tempFormData.length > 0 && this.pageData.length === 0) { // 任务发起审批带过来的关联数据
                    this.tempFormData.forEach(item => {
                        if (item.formId === model.formId) { // 可能会有多个关联字段，所以过滤数据显示
                            this.pageData.unshift(item.forms[0].values); // 用于显示到列表中
                            this.page.totalPageNum = this.page.totalPageNum + 1;
                        }
                    });
                    if (this.pageData.length === 0) {
                        let tableDatas = [];
                        formData.data.forEach(item => {
                            let jsonObj = JSON.parse(item);
                            tableDatas.push(jsonObj);
                        });
                        this.pageData = tableDatas;
                    }
                } else {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        // tableDatas.push(jsonObj);
                        if (jsonObj.id) {
                            tableDatas.push(jsonObj);
                        }
                    });
                    if (this.pageData.length === 0) { // 防止新增了数据后。切换tab页签，刷新掉。
                        this.pageData = tableDatas;
                        for (let i = 0; i < this.pageData.length; i++) {
                            let data = this.pageData[i];
                            let formData = {
                                forms: [
                                    {
                                        ext1: 0,
                                        colSpan: 1,
                                        formId: this.selectedModel.formId,
                                        values: {}
                                    }
                                ]
                            };
                            formData.modelId = this.selectedModel.id;
                            formData.formId = this.selectedModel.formId;
                            formData.forms[0].values = data;
                            formData.forms[0].formId = this.selectedModel.formId;
                            // let uuid = getUUID(16, 16);
                            formData.forms[0].values.id = data.id;
                            formData.forms[0].values.rowspan = 1;
                            formData.forms[0].values.num = i;
                            formData.forms[0].values.isOldData = true;
                            let flag = true;
                            if (this.tempFormData.length > 0) {
                                for (let j = 0; j < this.tempFormData.length; j++) {
                                    let cur = this.tempFormData[j];
                                    if (cur.forms[0].values.id === data.id) {
                                        flag = false;
                                        break;
                                    }
                                }
                                if (flag) {
                                    this.tempFormData.push(formData); // 主数据保存后再保存的关联表单数据
                                }
                            } else {
                                this.tempFormData.push(formData);
                            }
                        }
                    }
                    // this.pageData = tableDatas;
                }
            } else {
                this.pageData = [];
            }
            if (formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                this.allTableColumns = cloneDeep(_tableColumns);
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            if (formData.otherData.fieldsList) {
                this.fieldsList = formData.otherData.fieldsList;
            }
            if (isInitSearch) {
                this.$emit('refreshSearchConditon', this.tableColumns);
            }
            this.subformTableColumns = formData.otherData.subformTableColumns;
            // 如果是初次查询，需要获取isApprovalForm值，否则按照状态查询，则不需要重新赋值
            if (this.isInit) {
                this.isApprovalForm = formData.otherData.isApprovalForm;
            }
            if (formData.otherData.approvalList) {
                this.approvalList = formData.otherData.approvalList;
            }
            this.isShowDown = formData.otherData.isShowDown;
            if (this.$refs.dynamicTable) {
                this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
            }
            this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;

            // 是否要显示合计行
            this.filterSumTableColumns();

            // 协同办公任务驳回后，协同办公首任务的关联表单复用历史数据
            // if (formData && isEmpty(formData.data) && this.pageData.length === 0) {//不需要加载历史数据
            // if (formData && model.mainFormDataId && this.pageData.length === 0) {
            //     if (this.taskInfo) {
            //         await this.reloadHisData(formData);
            //     }
            // }
            // 更新table高度  dynamicTable
            this.time = new Date().getTime();
            // if (isReStartApproval) { // 驳回后发起审批时初始化加载原有子表单数据
            //     this.initRestartApprovalSubFormData();
            // }
        },
        initRestartApprovalSubFormData () {
            for (let i = 0; i < this.pageData.length; i++) {
                let data = this.pageData[i];
                let formData = {
                    forms: [
                        {
                            ext1: 0,
                            colSpan: 1,
                            formId: this.selectedModel.formId,
                            values: {}
                        }
                    ]
                };
                formData.modelId = this.selectedModel.id;
                formData.formId = this.selectedModel.formId;
                formData.forms[0].values = data;
                formData.forms[0].formId = this.selectedModel.formId;
                let uuid = getUUID(16, 16);
                formData.forms[0].values.id = uuid;
                formData.forms[0].values.rowspan = 1;
                formData.forms[0].values.num = 1;
                formData.forms[0].values.isOldData = false;
                this.tempFormData.push(formData); // 主数据保存后再保存的关联表单数据
            }
        },
        getIfSubform (tableColumns) {
            let isSubform = false;
            for (var i = 0; i < tableColumns.length; i++) {
                // 判断是否含有子表单列
                if (tableColumns[i].subcolumn) {
                    isSubform = true;
                    break;
                }
            }
            return isSubform;
        },
        async handleNavModelFormEdit (row) {
            if (row.id && row.id.length === 16) {
                if (this.tempFormData) {
                    this.formInfo = {};
                    let currFormData = {};
                    for (let i = 0; i < this.tempFormData.length; i++) {
                        let data = cloneDeep(this.tempFormData[i]);
                        let id = data.forms[0].values.id;
                        let subRelateFormId = data.forms[0].values.subRelateFormId;
                        // console.log(row);
                        // console.log(data);
                        if (id === row.id) {
                            currFormData = data.forms[0];
                            break;
                        } else if (row.subRelateFormId && subRelateFormId && row.subRelateFormId === subRelateFormId) { // 协同办公首任务修改
                            currFormData = data.forms[0];
                            break;
                        }
                    }
                    // console.log(currFormData);
                    this.formInfo = await getModelFormById(this.selectedModel.id);
                    this.formInfo.formObj.instance = JSON.stringify(currFormData);
                    this.formInfo.formId = this.selectedModel.formId;
                    this.formInfo.modelName = this.selectedModel.modelName;
                    this.formInfo.appName = this.selectedModel.fappName;
                    this.formInfo.remarks = this.selectedModel.remarks;
                    this.formInfo.modelType = this.selectedModel.modelType;
                    this.isShowModelDetail = true;
                    this.isShowForm = false;
                    this.isRead = false;
                    // console.log(row);
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.relateModelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, this.isShowDown);
                    }, 0);
                    this.active = true;
                }
            } else {
                this.formInfo = await getModelFormInstanceById(row.id);
                if (this.formInfo) {
                    this.formInfo.formId = this.selectedModel.formId;
                    this.formInfo.modelName = this.selectedModel.modelName;
                    this.formInfo.appName = this.selectedModel.fappName;
                    this.formInfo.remarks = this.selectedModel.remarks;
                    this.formInfo.modelType = this.selectedModel.modelType;
                    this.isShowModelDetail = true;
                    this.isShowForm = false;
                    this.isRead = false;
                    // console.log(this.formInfo);
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.relateModelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, this.isShowDown);
                    }, 0);
                }
                this.active = true;
            }
        },
        handleModelFormDelete (row) {
            this.$confirm(`您确定要删除当前数据吗？被删除的数据不会被恢复。`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                await delModelFormInstance(row.id);
                await this.queryFormData(this.page);
                this.active = false;
            }).catch(() => { });
        },
        async handleModelComplete (formData) {
            // console.log('=======================');
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let idEdit = false;
                let tempData = cloneDeep(formData);
                // console.log(tempData);
                for (let i = 0; i < this.pageData.length; i++) {
                    let data = this.pageData[i];
                    if (tempData.forms[0].values.hasOwnProperty('id') && data.id === tempData.forms[0].values.id) { // 修改
                        this.pageData[i] = tempData.forms[0].values;
                        idEdit = true;
                        this.time = new Date().getTime();
                        break;
                    } else if (tempData.forms[0].values.hasOwnProperty('subRelateFormId') && data.subRelateFormId && data.subRelateFormId === tempData.forms[0].values.subRelateFormId) {
                        this.pageData[i] = tempData.forms[0].values;
                        idEdit = true;
                        this.time = new Date().getTime();
                        break;
                    }
                }
                // console.log(idEdit);
                if (!idEdit) { // 新增
                    formData.modelId = this.selectedModel.id;
                    formData.formId = this.selectedModel.formId;
                    let uuid = getUUID(16, 16);
                    formData.forms[0].values.id = uuid;
                    formData.forms[0].values.rowspan = 1;
                    formData.forms[0].values.num = 1;
                    formData.forms[0].values.isOldData = false;
                    this.tempFormData.push(formData); // 主数据保存后再保存的关联表单数据
                    let newFormData = formData.forms[0].values;
                    this.pageData.unshift(newFormData); // 用于显示到列表中
                    // console.log(this.tempFormData);
                    // console.log(this.pageData);
                    this.tableLoading = true;
                    if (this.$refs.dynamicTable) {
                        this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
                    }
                    this.page.totalPageNum = this.page.totalPageNum + 1;
                } else {
                    let matchFlg = false;
                    for (let index = 0; index < this.tempFormData.length; index++) {
                        if (tempData.forms[0].values.hasOwnProperty('id') && tempData.forms[0].values.id === this.tempFormData[index].forms[0].values.id) {
                            this.tempFormData[index].forms[0].values = tempData.forms[0].values;
                            matchFlg = true;
                            break;
                        } else if (tempData.forms[0].values.hasOwnProperty('subRelateFormId') && (tempData.forms[0].values.subRelateFormId === this.tempFormData[index].forms[0].values.subRelateFormId)) {
                            this.tempFormData[index].forms[0].values = tempData.forms[0].values;
                            matchFlg = true;
                            break;
                        }
                    }
                    if (!matchFlg) {
                        tempData.modelId = this.selectedModel.id;
                        tempData.formId = this.selectedModel.formId;
                        tempData.forms[0].values.rowspan = 1;
                        tempData.forms[0].values.num = 1;
                        // tempData.forms[0].values.isOldData = true;
                        this.tempFormData.push(tempData);
                    }
                }
                // console.log(this.tempFormData);
                // console.log(this.approvalStatus);
                if (this.approvalStatus == 10) {
                    this.$emit('refreshTempFormData', this.tempFormData);
                }
                this.$emit('refTempFormData', this.tempFormData);
                this.tableLoading = false;
                this.active = false;
            } catch (error) {
                console.error('保存表单数据异常：', error);
            } finally {
                loading.close();
            }
        },
        async handleModelReportComplete (model) {
            await saveAppModelForm(model.modelId, model);
            this.isShowOrgTreeDialog = false;
            await this.queryFormData(this.page);
        },
        async addFormData () {
            // 校验是否有权限录入数据(同关联组件处的新增表单逻辑)
            // 切换到表单录入
            this.formInfo = await getModelFormById(this.selectedModel.id);
            this.formInfo.modelName = this.formInfo.formObj.structure[0].modelName;
            this.formInfo.appName = this.formInfo.formObj.structure[0].appName;
            this.formInfo.remarks = this.formInfo.formObj.structure[0].remarks;
            this.formInfo.modelType = this.formInfo.formObj.structure[0].modelType;
            this.formInfo.formId = this.selectedModel.formId;
            this.isShowModelDetail = true;
            let uuid = getUUID(16, 16);
            let initCurrentData = { id: uuid, approvalInstanceId: '' };
            initCurrentData.rowspan = 1;
            initCurrentData.num = 1;
            initCurrentData.isOldData = false;
            // 将主表的关联数据赋值给子表的关联字段
            this.formInfo.formObj.structure[0].fieldsList.forEach(element => {
                // if (element.type === 'link') {
                //     // 解析主表数据，找出跟子表关联字段的关联表单一样的那个主表字段的值
                //     for (let i = 0; i < this.mainLinkFieldList.length; i++) {
                //         let mainField = this.mainLinkFieldList[i];
                //         if (mainField.options.config.form.formId === element.options.config.form.formId) {
                //             if (this.parentFormData && this.parentFormData.length > 0) {
                //                 let mainFormData = this.parentFormData[0].values;
                //                 // 取出 xxx、xxx-view、xxx-link等值
                //                 initCurrentData[element.id] = mainFormData[mainField.id];
                //                 initCurrentData[element.id + '-view'] = mainFormData[mainField.id + '-view'];
                //                 initCurrentData[element.id + '-link'] = mainFormData[mainField.id + '-link'];
                //             }
                //         }
                //     }
                // }

                // 解析主表数据，找出跟子表关联字段的关联表单一样的那个主表字段的值
                let mainFormData = null;
                if (this.parentFormData && this.parentFormData.length > 0) {
                    mainFormData = this.parentFormData[0].values;
                }
                for (let i = 0; i < this.mainLinkFieldList.length; i++) {
                    let mainField = this.mainLinkFieldList[i];
                    if (element.type === 'link' && mainField.type === 'link') {
                        if (mainField.options.config.form.formId === element.options.config.form.formId) {
                            if (mainFormData) {
                                // 取出 xxx、xxx-view、xxx-link等值
                                initCurrentData[element.id] = mainFormData[mainField.id];
                                initCurrentData[element.id + '-view'] = mainFormData[mainField.id + '-view'];
                                initCurrentData[element.id + '-link'] = mainFormData[mainField.id + '-link'];
                            }
                        }
                    }
                    if (element.options.synLinkField && element.options.synLinkFormFieldId && element.options.synLinkFormFieldId === mainField.id) {
                        this.setFieldData(element, mainField, mainFormData, initCurrentData);
                    }
                }
            });
            // console.log('===========');
            this.active = true;
            setTimeout(() => {
                this.$refs.relateModelInstance.loadFormData(this.formInfo, true, initCurrentData);
            }, 0);
        },
        setFieldData (element, sourceEle, sourceData, targetData) { // 设置字段默认值
            let type = sourceEle.type;
            let sourceId = sourceEle.id;
            let sourceValueKey = ''; // 对应userId等唯一性值
            let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
            if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                sourceDepartmentValueKey = sourceData[sourceId];
                sourceValue = sourceData[sourceId + '-tree'];
            } else if (type === 'user') {
                sourceValue = sourceData[sourceId + '-user'];
            } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                sourceValue = sourceData[sourceId + '-view'];
            } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                sourceValue = sourceData[sourceId];
            } else if (type === 'link') {
                sourceValue = sourceData[sourceId + '-view'];
            } else {
                sourceValue = sourceData[sourceId];
            }

            if (element.type === 'text') {
                targetData[element.id] = sourceValue;
                targetData[element.id + '-view'] = '';
            } else if (element.type === 'number' || element.type === 'calculation') {
                if (!isEmpty(sourceValue)) {
                    targetData[element.id] = sourceValue;
                    targetData[element.id + '-view'] = '';
                } else {
                    targetData[element.id] = '';
                    targetData[element.id + '-view'] = '';
                }
            } else if (element.type === 'user') {
                if (!isEmpty(sourceValue)) {
                    targetData[element.id] = sourceValueKey;
                    targetData[element.id + '-user'] = sourceValue;
                } else {
                    targetData[element.id] = '';
                    targetData[element.id + '-user'] = '';
                }
            } else if (element.type === 'department') {
                if (!isEmpty(sourceValue)) {
                    targetData[element.id] = sourceDepartmentValueKey;
                    targetData[element.id + '-tree'] = sourceValue;
                } else {
                    targetData[element.id] = '';
                    targetData[element.id + '-tree'] = '';
                }
            } else if (element.type === 'select') {
                // console.log(element);
                if (!isEmpty(sourceValue)) {
                    // 下拉选项值
                    let targetFieldValue = {};
                    let targetFieldOptions = element.options.config.options;
                    for (let i = 0; i < targetFieldOptions.length; i++) {
                        let optionItem = targetFieldOptions[i];
                        if (optionItem.title === sourceValue) {
                            targetFieldValue = optionItem;
                            break;
                        }
                    }
                    if (targetFieldValue) {
                        targetData[element.id] = targetFieldValue.value;
                        targetData[element.id + '-view'] = targetFieldValue.title;
                    }
                } else {
                    targetData[element.id] = '';
                    targetData[element.id + '-view'] = '';
                }
            } else {
                targetData[element.id] = sourceValue;
            }
        },
        async quoteFormData () {
            // 获取草稿状态下保存的数据ID，然后查询列表的时候id not in 草稿的ID
            let formId = this.parentFormInfo.formId;
            let param = { formId: formId };
            let idsArray = [];
            if (formId !== 'dc36ba40d7664d09aa110e256e424a11') {
                let res = await getModelFormByDraft(param);
                idsArray = res.ids;
                for (let i = 0; i < idsArray.length; i++) {
                    let cur = idsArray[i];
                    if (this.cacheDeleteDataIds.indexOf(cur) !== -1) {
                        idsArray.splice(i, 1);
                    }
                }
            }
            // 查询当前关联字表未绑定主表的数据
            this.formInfo = await getModelFormById(this.selectedModel.id);
            // 将主表的关联数据赋值给子表的关联字段
            this.formInfo.formObj.structure[0].fieldsList.forEach(element => {
                if (element.type === 'link') {
                    // 解析主表数据，找出跟子表关联字段的关联表单一样的那个主表字段的值
                    if (this.parentFormInfo.formId === element.options.config.form.formId) {
                        this.$nextTick(() => {
                            if (this.tempFormData && this.tempFormData.length > 0) {
                                for (let i = 0; i < this.tempFormData.length; i++) {
                                    let cur = this.tempFormData[i];
                                    let id = cur.forms[0].values.id;
                                    if (id) {
                                        idsArray.push(id);
                                    }
                                }
                            }

                            // 获取当前表单关联的数据，把id 过滤掉
                            this.getFormList(element.id, element.formId, element.modelId, null, idsArray.join(','));
                            this.popQuoteModelCache.id = element.id;
                            this.popQuoteModelCache.formId = element.formId;
                            this.popQuoteModelCache.modelId = element.modelId;
                        });
                    }
                }
            });
        },
        searchParam (searchArray) {
            // let searchArray = [];
            if (this.parentFormInfo.formId === 'e75e01ad23b343809ac16bf69302f24d') { // 中兴华咨提成报销
                // 根据子表单构造搜索条件
                if (this.selectedModel.formId === '14f9bcb3c4c44cb1853e0e864f0d7e8f') { // 房地产个人绩效明细
                    let applyUser = {// 取出当前绩效申请人
                        'id': '0cb50fc9316a416882acd3ce4d3ff174',
                        'type': 'link',
                        'name': '绩效申请人员',
                        'icon': '&#xe654;',
                        'formField': 'link_14f9bcb3c4c44cb1853e0e864f0d7e8f',
                        'formId': '14f9bcb3c4c44cb1853e0e864f0d7e8f',
                        'operateType': 1,
                        'modelId': 'b6698cc0159a40af8c7502e996effcf9',
                        'isView': true,
                        'conditionValue': this.userInfo.trueName,
                        'searchFieldId': '0cb50fc9316a416882acd3ce4d3ff174-view',
                        'modelName': '房地产个人绩效明细'
                    };
                    let ffState = {// 取出发放状态
                        'id': '46a09e3598a942c1bab984d4ad845654',
                        'type': 'select',
                        'name': '发放状态',
                        'icon': '&#xe654;',
                        'formField': '46a09e3598a942c1bab984d4ad845654',
                        'formId': '14f9bcb3c4c44cb1853e0e864f0d7e8f',
                        'operateType': 1,
                        'modelId': 'b6698cc0159a40af8c7502e996effcf9',
                        'isView': true,
                        'conditionValue': 'A77DFD2C',
                        'conditionValueView': '未发放',
                        'modelName': '房地产个人绩效明细'
                    };
                    let approveState = {// 取出审核状态
                        'id': 'd89f19495d7e49aba5801b2989a99382',
                        'type': 'select',
                        'name': '审核状态',
                        'icon': '&#xe654;',
                        'formField': 'd89f19495d7e49aba5801b2989a99382',
                        'formId': '14f9bcb3c4c44cb1853e0e864f0d7e8f',
                        'operateType': 1,
                        'modelId': 'b6698cc0159a40af8c7502e996effcf9',
                        'isView': true,
                        'conditionValue': 'B8E4D451',
                        'conditionValueView': '通过',
                        'modelName': '房地产个人绩效明细'
                    };
                    // 关联提成单没有数据的数据
                    // let tcState = {// 取出关联提成
                    //     'id': '445f948be4034d019ae49c3e428e8fb9',
                    //     'type': 'link',
                    //     'name': '所属提成单',
                    //     'icon': '',
                    //     'formField': 'link_14f9bcb3c4c44cb1853e0e864f0d7e8f',
                    //     'formId': '14f9bcb3c4c44cb1853e0e864f0d7e8f',
                    //     'tenantId': '2a19bf2841304dd5b4ef566ed536ecf7',
                    //     'ext2': '',
                    //     'operateType': 2,
                    //     'modelId': 'b6698cc0159a40af8c7502e996effcf9',
                    //     'isView': true,
                    //     'modelName': '房地产个人绩效明细',
                    //     'searchFieldId': '445f948be4034d019ae49c3e428e8fb9-view'
                    // };
                    searchArray.push(applyUser);
                    searchArray.push(ffState);
                    searchArray.push(approveState);
                    // searchArray.push(tcState);
                } else if (this.selectedModel.formId === '822a1c99d5164875aa5257ee6fd88150') { // 工程咨询个人绩效明细
                    let applyUser = {// 取出当前绩效申请人
                        'id': '234884c4f0e741d6af4c19237d3ee4fd',
                        'type': 'link',
                        'name': '绩效申请人员',
                        'icon': '&#xe654;',
                        'formField': '234884c4f0e741d6af4c19237d3ee4fd',
                        'formId': '822a1c99d5164875aa5257ee6fd88150',
                        'operateType': 1,
                        'modelId': 'd5b25ed8702a4392a3c435c795bb9dd7',
                        'isView': true,
                        'conditionValue': this.userInfo.trueName,
                        'searchFieldId': '234884c4f0e741d6af4c19237d3ee4fd-view',
                        'modelName': '工程咨询个人绩效明细(新)'
                    };
                    let ffState = {// 取出发放状态
                        'id': '44f5af51028041e1a0a39139fbf1eb33',
                        'type': 'select',
                        'name': '发放状态',
                        'icon': '&#xe654;',
                        'formField': '44f5af51028041e1a0a39139fbf1eb33',
                        'formId': '822a1c99d5164875aa5257ee6fd88150',
                        'operateType': 1,
                        'modelId': 'd5b25ed8702a4392a3c435c795bb9dd7',
                        'isView': true,
                        'conditionValue': 'BBDCBFE7',
                        'conditionValueView': '未发放',
                        'modelName': '工程咨询个人绩效明细(新)'
                    };
                    let approveState = {// 审核状态
                        'id': 'b6bc49c9ea7a46548acc3f8714912fd3',
                        'type': 'select',
                        'name': '审批状态',
                        'icon': '&#xe654;',
                        'formField': 'b6bc49c9ea7a46548acc3f8714912fd3',
                        'formId': '822a1c99d5164875aa5257ee6fd88150',
                        'operateType': 1,
                        'modelId': 'd5b25ed8702a4392a3c435c795bb9dd7',
                        'isView': true,
                        'conditionValue': 'B8E4D451',
                        'conditionValueView': '通过',
                        'modelName': '工程咨询个人绩效明细(新)'
                    };
                    // 关联提成单没有数据的数据
                    // let tcState = {// 取出关联提成
                    //     'id': 'd0aaff219ae64c61845f2481562ecdb1',
                    //     'type': 'link',
                    //     'name': '所属提成单',
                    //     'icon': '&#xe654;',
                    //     'formField': 'd0aaff219ae64c61845f2481562ecdb1',
                    //     'formId': '822a1c99d5164875aa5257ee6fd88150',
                    //     'tenantId': '2a19bf2841304dd5b4ef566ed536ecf7',
                    //     'ext2': '',
                    //     'operateType': 2,
                    //     'modelId': 'd5b25ed8702a4392a3c435c795bb9dd7',
                    //     'isView': true,
                    //     'modelName': '工程咨询个人绩效明细(新)',
                    //     'searchFieldId': 'd0aaff219ae64c61845f2481562ecdb1-view'
                    // };
                    searchArray.push(approveState);
                    searchArray.push(applyUser);
                    searchArray.push(ffState);
                    // searchArray.push(tcState);
                } else if (this.selectedModel.formId === '9ee70152560a4dce9da723777ddfa560') { // 资产评估个人绩效明细
                    let applyUser = {// 取出当前绩效申请人
                        'id': 'e96b02b7998343a284550d7a43bd21b1',
                        'type': 'link',
                        'name': '绩效申请人员',
                        'icon': '&#xe654;',
                        'formField': 'e96b02b7998343a284550d7a43bd21b1',
                        'formId': '9ee70152560a4dce9da723777ddfa560',
                        'operateType': 1,
                        'modelId': '12ef9b63350c4eecbb1cde39e49b5bfc',
                        'isView': true,
                        'conditionValue': this.userInfo.trueName,
                        'searchFieldId': 'e96b02b7998343a284550d7a43bd21b1-view',
                        'modelName': '资产个人绩效明细'
                    };
                    let ffState = {// 取出发放状态
                        'id': '48bb4281d6f6479b972a41071e9fac75',
                        'type': 'select',
                        'name': '发放状态',
                        'icon': '&#xe654;',
                        'formField': '48bb4281d6f6479b972a41071e9fac75',
                        'formId': '9ee70152560a4dce9da723777ddfa560',
                        'operateType': 1,
                        'modelId': '12ef9b63350c4eecbb1cde39e49b5bfc',
                        'isView': true,
                        'conditionValue': '9F628C2C',
                        'conditionValueView': '未发放',
                        'modelName': '资产个人绩效明细'
                    };
                    let approveState = {// 取出审核状态
                        'id': 'dbbcdf2913464a0b8c503d83353fc9b5',
                        'type': 'select',
                        'name': '审批状态',
                        'icon': '&#xe654;',
                        'formField': 'dbbcdf2913464a0b8c503d83353fc9b5',
                        'formId': '9ee70152560a4dce9da723777ddfa560',
                        'operateType': 1,
                        'modelId': '12ef9b63350c4eecbb1cde39e49b5bfc',
                        'isView': true,
                        'conditionValue': 'B8E4D451',
                        'conditionValueView': '通过',
                        'modelName': '资产个人绩效明细'
                    };
                    // 关联提成单没有数据的数据
                    // let tcState = {// 取出关联提成
                    //     'id': '6b2faba4132a4469b46528554bb20c7e',
                    //     'type': 'link',
                    //     'name': '所属提成单',
                    //     'icon': '&#xe654;',
                    //     'formField': '6b2faba4132a4469b46528554bb20c7e',
                    //     'formId': '9ee70152560a4dce9da723777ddfa560',
                    //     'tenantId': '2a19bf2841304dd5b4ef566ed536ecf7',
                    //     'ext2': '',
                    //     'operateType': 2,
                    //     'modelId': '12ef9b63350c4eecbb1cde39e49b5bfc',
                    //     'isView': true,
                    //     'modelName': '资产个人绩效明细',
                    //     'searchFieldId': '6b2faba4132a4469b46528554bb20c7e-view'
                    // };
                    searchArray.push(approveState);
                    searchArray.push(applyUser);
                    searchArray.push(ffState);
                    // searchArray.push(tcState);
                }
            }
        },

        async getFormList (fieldId, formId, modelId, searchConditionArray, notIds) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.popQuotePageData = [];
            let searchCondition = [];
            let curItem = {
                'id': fieldId,
                'type': 'link',
                'name': '项目名称',
                'icon': '&#xe654;',
                'formField': fieldId,
                'formId': formId,
                'operateType': 2,
                'modelId': modelId,
                'isView': true,
                'conditionValue': '',
                'searchFieldId': fieldId,
                'isEmptySearchItem': false
            };
            if (searchConditionArray && searchConditionArray.length > 0) {
                searchCondition = searchConditionArray;
                searchCondition.push(curItem);
            } else {
                searchCondition.push(curItem);
            }
            this.searchParam(searchCondition);
            let param = {
                formId: formId,
                isFilterDuplicateData: false,
                isShowProcess: false,
                modelId: modelId,
                name: '',
                searchCondition: searchCondition,
                selectedApprovalStatus: '',
                selectedFields: '',
                selectedMonthStr: '',
                notIds: notIds,
                isMainSonForm: true
            };
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.popQuotePage.currentPage,
                pageSize: this.popQuotePage.pageSize
            }, param));
            if (formData && formData.otherData && formData.otherData.searchCondition) {
                this.conditionFields = JSON.parse(formData.otherData.searchCondition);
            }
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                if (this.popQuotePageData.length === 0) { // 防止新增了数据后。切换tab页签，刷新掉。
                    this.popQuotePageData = tableDatas;
                }
            }
            if (formData.otherData.tableColumns) {
                this.popQuoteTableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                this.allTableColumns = cloneDeep(_tableColumns);
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.popQuoteTableColumns.push(item);
                    }
                });
            }
            if (formData.otherData.fieldsList) {
                this.popQuoteFieldsList = formData.otherData.fieldsList;
            }
            this.subformTableColumns = formData.otherData.subformTableColumns;
            // 如果是初次查询，需要获取isApprovalForm值，否则按照状态查询，则不需要重新赋值
            if (this.isInit) {
                this.isApprovalForm = formData.otherData.isApprovalForm;
            }
            if (formData.otherData.approvalList) {
                this.approvalList = formData.otherData.approvalList;
            }
            this.isShowDown = formData.otherData.isShowDown;
            if (this.$refs.popQuoteDynamicTable) {
                this.$refs.popQuoteDynamicTable.setMergeSpanArr(this.popQuotePageData);
            }
            this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            this.popQuotePage = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
            // 是否要显示合计行
            this.filterSumTableColumns();
            this.popQuoteFormList = true;
            loading.close();
        },
        async renderModelDetail (model) {
            // this.modelId = model.id;
            this.formInfo = await getModelFormById(model.id);
            this.formInfo.modelName = model.modelName;
            this.formInfo.appName = model.fappName;
            this.formInfo.remarks = model.remarks;
            this.formInfo.modelType = model.modelType;
            this.formInfo.formId = model.formId;
        },
        handleFullScreen () {
            this.$emit('handleFullScreen');
        },
        handleSearch () {
            this.isShowExcelData = false;
            this.queryFormData(this.page);
        },
        async dataImport () {
            const param = {};
            param.modelId = this.selectedModel.id;
            setTimeout(() => { // 调用子组件的方法
                this.$refs.excelInstance.initParam(param);
            }, 0);
            this.isShowExcelData = true;
        },
        async dataExport () {
            let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
            if (this.showSummary) {
                this.$confirm('是否将汇总值一起导出', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.needSumData = true;
                    if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                        this.downloadAllLink(url);
                    } else {
                        this.download(url);
                    }
                }).catch(() => {
                    this.needSumData = false;
                    this.download(url);
                });
            } else {
                this.needSumData = false;
                if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                    this.downloadAllLink(url);
                } else {
                    this.download(url);
                }
            }
        },
        async dataCurrentExport () {
            let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
            if (this.showSummary) {
                this.$confirm('是否将汇总值一起导出', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.needSumData = true;
                    if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                        this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                            confirmButtonText: '否',
                            cancelButtonText: '是',
                            type: 'warning'
                        }).then(() => {
                            this.download(url, false, true);
                        }).catch(() => {
                            url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                            this.download(url, true, true);
                        });
                    } else {
                        this.download(url, false, true);
                    }
                }).catch(() => {
                    this.needSumData = false;
                    this.download(url, false, true);
                });
            } else {
                this.needSumData = false;
                if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                    if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                        this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                            confirmButtonText: '否',
                            cancelButtonText: '是',
                            type: 'warning'
                        }).then(() => {
                            this.download(url, false, true);
                        }).catch(() => {
                            url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                            this.download(url, true, true);
                        });
                    } else {
                        this.download(url, false, true);
                    }
                } else {
                    this.download(url, false, true);
                }
            }
        },
        downloadAllLink (url) {
            this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                confirmButtonText: '否',
                cancelButtonText: '是',
                type: 'warning'
            }).then(() => {
                this.download(url);
            }).catch(() => {
                url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                this.download(url, true);
            });
        },
        async download (url, needLinkSelectField = false, current) {
            let selectedMonthStr = '';
            if (this.selectedMonth && this.fromReport) {
                selectedMonthStr = this.selectedMonth[0] + ',' + this.selectedMonth[1];
            }

            let newSearchConditionExt = cloneDeep(this.searchParams);
            if (!this.oldSelectedModel.root && this.oldSelectedModel.leftTreeMode) {
                newSearchConditionExt.searchCondition = newSearchConditionExt.searchCondition.concat(this.searchConditionExt);
            }
            let param = {
                modelId: this.selectedModel.id,
                formId: this.searchParams.formId,
                mainFormId: this.searchParams.mainFormId,
                selectedFields: this.searchParams.selectedFields,
                mainFormDataId: this.searchParams.mainFormDataId,
                isFilterDuplicateData: false,
                isFormulaSearch: true,
                isApprovalForm: this.isApprovalForm,
                needSumData: this.needSumData,
                needLinkSelectField: needLinkSelectField,
                selectedApprovalStatus: this.searchParams.selectedApprovalStatus,
                isViewApprovalInfo: this.searchParams.isViewApprovalInfo,
                formDataId: this.formDataId, // 单条数据导出需要数据id
                isCurrentExport: current === true ? 1 : 0,
                selectedMonthStr: selectedMonthStr,
                searchCondition: JSON.stringify(this.searchParams.searchCondition)
            };
            if (current) {
                param.moreIds = this.moreIds;
                param.page = JSON.stringify(this.page);
            }
            param.reportAggregateSearch = this.isReportAggregateSearch;
            let res = await getExcelDataExportId(param);
            this.formDataId = '';
            if (res && res.data) {
                url = `${API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID}`;
                url = url.replace(':exportId', res.data);
            } else {
                let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
                url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':isApprovalForm', this.isApprovalForm).replace(':needSumData', this.needSumData);
            }
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        download_bak (url) {
            let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
            url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':isApprovalForm', this.isApprovalForm).replace(':needSumData', this.needSumData);
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        async handleFilterCondition () {
            this.isShowSearchConditon = false;
            if (this.cacheSearchField.length < 1) {
                let columns = cloneDeep(this.popQuoteTableColumns);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                this.cacheSearchField = this.conditionFields;
                loading.close();
            } else {
                this.conditionFields = this.cacheSearchField;
            }
            this.isShowSearchConditon = true;
        },
        handleFilterField () {
            this.isShowFilterField = true;
            if (this.isRefreshSel) {
                this.sourceOptions = [];
                let tableColumnsView = cloneDeep(this.tableColumns);
                tableColumnsView.forEach((field) => {
                    if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                        this.sourceOptions.push(field);
                    }
                });
                this.sourceOptions.unshift({ id: 'ALL_SELECT', label: 'ALL' });
                if (this.selectedModel.modelType === 0) {
                    this.sourceOptions.push({ id: 'appCreatedByName', label: '应用录入人' });
                    this.sourceOptions.push({ id: 'appCreatedByDate', label: '应用录入时间' });
                    // 因为多了流程选择，所以在这里去掉了
                }
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 100);
                this.isRefreshSel = false;
            }
        },
        async chooseViewField () {
            this.isShowFilterField = false;
            this.fieldTime = new Date().getTime();
            let selectedFields = this.$refs.selectMultiple.getSelectFields();
            this.searchParams.selectedFields = selectedFields;
            this.queryFormData(this.page);
        },
        async clearViewField () {
            let param = { formId: this.selectedModel.formId, modelId: this.selectedModel.id };
            let res = await updateUserFormViewField(param);
            if (res.state === 'success') {
                this.fieldTime = new Date().getTime();
                let selectedFields = this.$refs.selectMultiple.getSelectFields();
                this.searchParams.selectedFields = selectedFields;
                this.queryFormData(this.page, true);
                this.isShowFilterField = false;
                this.isRefreshSel = true;
            }
        },
        async resetSearchConditon () {
            this.conditionFields.length = 0;
            let columns = cloneDeep(this.tableColumns);
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            this.conditionFields = await getFormFieldListByIds(idArr.join(','));
            // this.isShowSearchConditon = false;// 关闭查询条件框
            this.page.currentPage = 1;
            // this.queryFormData(this.page);// 查询条件重置后列表刷新
        },
        async chooseSearchConditon () {
            this.isShowSearchConditon = false;
            let searchCondition = this.$refs.searchConditon.getSearchCondition();
            this.searchParams.searchCondition = searchCondition;
            this.page.currentPage = 1;
            this.queryFormData(this.page);
        },
        async chooseRefSearchConditon () {
            this.isShowSearchConditon = false;
            let searchCondition = this.$refs.searchConditon.getSearchCondition();
            if (searchCondition && searchCondition.length > 0) {
                for (let i = 0; i < searchCondition.length; i++) {
                    let cur = searchCondition[i];
                    if (cur.id === this.popQuoteModelCache.id) {
                        searchCondition.splice(i, 1);
                    }
                    if (cur.type === 'link') {
                        cur.searchFieldId = cur.id + '-view';
                    }
                }
            }
            // 获取草稿状态下保存的数据ID，然后查询列表的时候id not in 草稿的ID
            let formId = this.parentFormInfo.formId;
            let param = { formId: formId };
            let res = await getModelFormByDraft(param);
            let idsArray = res.ids;
            for (let i = 0; i < idsArray.length; i++) {
                let cur = idsArray[i];
                if (this.cacheDeleteDataIds.indexOf(cur) !== -1) {
                    idsArray.splice(i, 1);
                }
            }
            this.popQuotePage.currentPage = 1;
            this.getFormList(this.popQuoteModelCache.id, this.popQuoteModelCache.formId, this.popQuoteModelCache.modelId, searchCondition, idsArray.join(','));
        },
        async searchForList (searchCondition, isInitSearch) {
            this.isShowSearchConditon = false;
            this.searchParams.searchCondition = searchCondition;
            // this.page.currentPage = 1;
            // this.queryFormData(this.page);
            this.renderFormList(this.selectedModel, isInitSearch);
        },
        setIsShowForm (status) {
            this.isShowForm = status;
        },
        async syncProcessData () {
            this.tableLoading = true;
            let param = { targetFormId: this.selectedModel.formId, targetModelId: this.selectedModel.id };
            await syncProcessFormData(param);
            await this.queryFormData(this.page);
            this.tableLoading = false;
        },
        hideDialog () {
            this.active = false;
            this.isShowModelDetail = false;
        },
        async handelSelectRow (params) {
            if (this.isModelForm) {
                this.handleNavModelFormEdit(params.row);
            }
        },
        async handelDbSelectRow (params) {
            if (this.selectedModel.modelType === 2) { // 报表类型,点击双击查看百川金字塔
                // console.log(params.row);
                this.showOrgTreeView(params.row);
            }
        },
        async handleView (rowInfo) {
            this.btnMode = 2;
            let row = await getApprovalInstanceDetail(rowInfo.approvalInstanceId);
            if (this.selectedRowId !== row.id) {
                await this.initApprovalPop(row);
            }
            this.isRead = true;
            this.isShowApprovalPop = true;
        },
        async initApprovalPop (row) {
            this.selectedRowId = row.id;
            this.templateInfo = row;
            this.templateInfo.selectedUser = {};
            this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
            this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
            this.templateInfo.templateName = row.approvalName;
            this.templateInfo.busiType = row.approvalType;
            this.templateInfo.busiTypeName = row.approvalTypeName;
            this.instances.id = row.processInstanceId;
            this.isInstance = true;
            await this.initStruct(row);
            setTimeout(() => { // 默认回显值
                this.$refs.approvalPop._initPage();
            }, 0);
        },
        async initStruct (row) {
            let formIds = [];
            row.forms.forEach(element => {
                formIds.push(element.formId);
            });
            let formsMap = await getFormConfigs(formIds.join(','));
            this.instances.formObj = {};
            this.instances.formObj.structure = [];
            this.instances.formObj.instance = row.formValues;
            for (var key in formsMap) {
                if (formsMap[key]) {
                    this.instances.formObj.structure.push(formsMap[key]);
                }
            }
        },
        async exportExcelData (rowInfo) {
            let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
            let approvalInstanceId = rowInfo.approvalInstanceId;
            let formDataId = rowInfo.id;
            this.formDataId = formDataId;
            let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
            url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':approvalInstanceId', approvalInstanceId).replace(':isApprovalForm', false).replace(':needSumData', false);
            url = url + '&formDataId=' + formDataId;
            if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                    confirmButtonText: '否',
                    cancelButtonText: '是',
                    type: 'warning'
                }).then(() => {
                    this.download(url);
                }).catch(() => {
                    url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                    this.download(url);
                });
            } else {
                this.download(url);
            }
        },
        handleApprovalStatusFilter () {
            this.isShowApprovalStatus = true;
            setTimeout(() => { // 调用子组件的方法
                this.$refs.selectApprovalStatus.initFields();// 每次切换model时清空显示字段
            }, 100);
        },
        async chooseApprovalStatusField (approvalStatus) {
            // 改为列表头筛选触发
            this.searchParams.selectedApprovalStatus = approvalStatus;
            this.queryFormData(1);
        },
        selectMore (params) {
            // this.isHasUNDel = params.isHasUNDel;
            // this.unDelNums = params.unDelNums;
            this.moreIds = params.ids;
            this.isHasUNDel = false;
            if (this.moreIds) {
                let idArray = this.moreIds.split(',');
                for (let i = 0; i < idArray.length; i++) {
                    let temDataId = idArray[i];
                    if (temDataId && temDataId.length === 32) {
                        this.isHasUNDel = true;
                        break;
                    }
                }
            }
        },
        popQuoteSelectMore (params) {
            this.popQuoteMoreIds = params.ids;
            // this.isHasUNDel = false;
            // if (this.moreIds) {
            //     let idArray = this.moreIds.split(',');
            //     for (let i = 0; i < idArray.length; i++) {
            //         let temDataId = idArray[i];
            //         if (temDataId && temDataId.length === 32) {
            //             this.isHasUNDel = true;
            //             break;
            //         }
            //     }
            // }
        },
        async handleModelFormBatchDelete () {
            if (this.moreIds) {
                this.$confirm(`您确定要批量删除当前数据吗？被删除的数据不会被恢复。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    this.active = true;
                    this.cacheDeleteDataIds = cloneDeep(this.moreIds);
                    let idArray = this.moreIds.split(',');
                    for (let i = 0; i < idArray.length; i++) {
                        let temDataId = idArray[i];
                        if (temDataId && temDataId.length === 32) {
                            await delModelFormInstance(temDataId);
                        }
                        // 删除临时list
                        for (let index = 0; index < this.tempFormData.length; index++) {
                            if (temDataId === this.tempFormData[index].forms[0].values.id) {
                                this.tempFormData.splice(index, 1);
                                break;
                            }
                        }
                        // 删除当前列表中的数据
                        for (let index = 0; index < this.pageData.length; index++) {
                            if (temDataId === this.pageData[index].id) {
                                this.pageData.splice(index, 1);
                                this.page.totalPageNum = this.page.totalPageNum - 1;
                                break;
                            }
                        }
                    }
                    if (this.approvalStatus == 10) {
                        this.$emit('refreshTempFormData', this.tempFormData);
                    }
                    this.$emit('refTempFormData', this.tempFormData);
                    this.active = false;
                }).catch(() => { });
            } else {
                this.messageTip('请先选择要删除的数据', 'warning');
                return false;
            }
        },
        handleHideOverflowTooltip () {
            if (this.hideOverflowTooltip) {
                this.isShowOverflowTooltip = false;
            } else {
                this.isShowOverflowTooltip = true;
            }
        },
        handleShowSummery () {
            if (this.isShowSummary) {
                this.showSummary = true;
            } else {
                this.showSummary = false;
            }
            this.time = new Date().getTime();
        },
        handleViewProcessInfo () {
            let tableColumnsView = cloneDeep(this.tableColumns);
            let selectedFields = '';
            let num = 0;
            tableColumnsView.forEach((field) => {
                if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                    if (num === 0) {
                        selectedFields = field.id;
                    } else {
                        selectedFields = selectedFields + ',' + field.id;
                    }
                    num++;
                }
            });
            if (this.isViewProcessInfo) {
                selectedFields = selectedFields + ',' + 'processInstanceName';
                this.isShowProcessInfo = true;
            } else {
                this.isShowProcessInfo = false;
            }
            if (!this.isViewApprovalInfo) {
                this.searchParams.selectedApprovalStatus = null;
            }
            this.searchParams.selectedFields = selectedFields;
            this.searchParams.isViewApprovalInfo = this.isViewApprovalInfo;
            this.queryFormData(1);
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        filterSumTableColumns () { // 过滤出需要求和的字段list
            this.isCanShowSummery = false;
            this.hasLinkField = false;
            // 将计算属性过滤出来
            this.tableColumns.forEach((mainItem, index) => {
                if (mainItem.type === 'number' || mainItem.type === 'calculation') {
                    this.isCanShowSummery = true;
                }
                if (mainItem.type === 'subform') {
                    let subColumns = mainItem.subColumns;
                    subColumns.forEach((subItem) => {
                        if (subItem.type === 'number' || subItem.type === 'calculation') {
                            this.isCanShowSummery = true;
                        }
                    });
                }
                if (mainItem.type === 'link') {
                    this.hasLinkField = true;
                }
            });
        },
        changeLeftTree (isCollapse) {
            this.$emit('collapseLeftSide', isCollapse);
        },
        changeLeftList () {
            this.isCollapse = true;
            this.$emit('setShowleftList');
            if (this.leftTitleFlag) {
                this.leftTitleFlag = false;
            } else {
                this.leftTitleFlag = true;
            }
        },
        async handelShowReportRelateTree () {
            this.loadTimer = new Date().getTime();
            setTimeout(() => {
                this.$refs.reportTreeList._initPage();
            }, 0);
            this.isShowReportRelateTree = true;
        },
        showList () {
            this.$emit('swtitcList');
        },
        showNewMenuSearch () {
            this.$emit('showSearch');
        },
        handleNavPage () { // 审批流发起或保存成功返回处理逻辑
            this.active = false;
            this.isShowModelDetail = false;
            this.$emit('handleNavPage');
        },
        async showOrgTreeView (row) { // 点击报表界面数据弹出对应数据一对多的百川金字塔图
            this.loadTimerReport = new Date().getTime();
            let formData = await getModelFormReportOrgTree(this.selectedModel.formId, row.id);
            this.treeOrgData = {};
            if (formData.data) {
                let tableDatas = {};
                formData.data.forEach(item => {
                    tableDatas = JSON.parse(item);
                });
                this.treeOrgData = tableDatas;
            }
            this.isShowOrgTreeDialog = true;
        },
        addRefFormData () {
            // console.log(this.pageData);
            // console.log(this.popQuoteMoreIds);
            // console.log(this.popQuotePageData);
            if (this.popQuoteMoreIds) {
                let idArray = this.popQuoteMoreIds.split(',');
                let flag = false;
                for (let i = 0; i < idArray.length; i++) {
                    let temDataId = idArray[i];
                    this.popQuotePageData.forEach(element => {
                        if (element.id === temDataId) {
                            let res = this.pageData.find(obj => obj.id === temDataId);
                            if (this.pageData.length === 50) {
                                flag = true;
                            } else {
                                if (!res) {
                                    this.pageData.push(element);
                                    let formValues = element.formValues;
                                    if (formValues) {
                                        let formValuesObj = JSON.parse(formValues);
                                        delete element.formValues;
                                        formValuesObj.values = element;
                                        let curItem = {
                                            formId: this.selectedModel.formId,
                                            modelId: this.selectedModel.id,
                                            forms: [
                                                formValuesObj
                                            ]
                                        };
                                        this.tempFormData.push(curItem);
                                    }
                                }
                            }
                        }
                    });
                }
                if (flag) {
                    this.$message.success('每次最多引用50条数据');
                }
            }
            if (this.approvalStatus == 10) {
                this.$emit('refreshTempFormData', this.tempFormData);
            }
            this.$emit('refTempFormData', this.tempFormData);
            // console.log(this.tempFormData);
            this.popQuoteFormList = false;
        },
        async popQuoteFormData ({ currentPage }) {
            // 获取草稿状态下保存的数据ID，然后查询列表的时候id not in 草稿的ID
            let formId = this.parentFormInfo.formId;
            let param = { formId: formId };
            let res = await getModelFormByDraft(param);
            let idsArray = res.ids;
            for (let i = 0; i < idsArray.length; i++) {
                let cur = idsArray[i];
                if (this.cacheDeleteDataIds.indexOf(cur) !== -1) {
                    idsArray.splice(i, 1);
                }
            }
            this.isInit = false;
            this.popQuotePage.currentPage = currentPage;
            this.getFormList(this.popQuoteModelCache.id, this.popQuoteModelCache.formId, this.popQuoteModelCache.modelId, null, idsArray.join(','));
        },
        async popQuoteFormDataByPageSize ({ pageSize }) {
            // 获取草稿状态下保存的数据ID，然后查询列表的时候id not in 草稿的ID
            let formId = this.parentFormInfo.formId;
            let param = { formId: formId };
            let res = await getModelFormByDraft(param);
            let idsArray = res.ids;
            for (let i = 0; i < idsArray.length; i++) {
                let cur = idsArray[i];
                if (this.cacheDeleteDataIds.indexOf(cur) !== -1) {
                    idsArray.splice(i, 1);
                }
            }
            this.isInit = false;
            this.popQuotePage.pageSize = pageSize;
            this.getFormList(this.popQuoteModelCache.id, this.popQuoteModelCache.formId, this.popQuoteModelCache.modelId, null, idsArray.join(','));
        },
        async createAchievementsData () {
            let loading = '';
            this.$confirm(`将会对当前表单设定的RPA规则进行数据动态生成，您确定要执行该操作吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                // await updRPARuleData({formId: this.parentFormInfo.formId});
                this.createAchievementsDataParam(loading);
                // this.getAchievementsData();
                loading.close();
            }).catch(() => {
                loading.close();
            });
        },
        async createAchievementsDataParam (loading) {
            // 获取草稿状态下保存的数据ID，然后查询列表的时候id not in 草稿的ID
            let formId = this.parentFormInfo.formId;
            let param = { formId: formId };
            let res = await getModelFormByDraft(param);
            let idsArray = res.ids;
            for (let i = 0; i < idsArray.length; i++) {
                let cur = idsArray[i];
                if (this.cacheDeleteDataIds.indexOf(cur) !== -1) {
                    idsArray.splice(i, 1);
                }
            }
            // 查询当前关联字表未绑定主表的数据
            this.formInfo = await getModelFormById(this.selectedModel.id);
            // 将主表的关联数据赋值给子表的关联字段
            this.formInfo.formObj.structure[0].fieldsList.forEach(element => {
                if (element.type === 'link') {
                    // 解析主表数据，找出跟子表关联字段的关联表单一样的那个主表字段的值
                    if (this.parentFormInfo.formId === element.options.config.form.formId) {
                        this.getAchievementsData(element.id, element.formId, element.modelId, null, idsArray.join(','), loading);
                        this.popQuoteModelCache.id = element.id;
                        this.popQuoteModelCache.formId = element.formId;
                        this.popQuoteModelCache.modelId = element.modelId;
                    }
                }
            });
        },
        async getAchievementsData (fieldId, formId, modelId, searchConditionArray, notIds, loading) { // 中兴华咨资产，房产，工程咨询绩效流程
            this.popQuotePageData = [];
            let searchCondition = [];
            let curItem = {
                'id': fieldId,
                'type': 'link',
                'name': '项目名称',
                'icon': '&#xe654;',
                'formField': fieldId,
                'formId': formId,
                'operateType': 2,
                'modelId': modelId,
                'isView': true,
                'conditionValue': '',
                'searchFieldId': fieldId,
                'isEmptySearchItem': true
            };
            let searchObj = {formId: formId};
            if (formId === '14f9bcb3c4c44cb1853e0e864f0d7e8f') { // 房地产个人绩效明细
                // let projectName = this.parentFormData[0].values['e813309b96dd49f0b0ea30b507c5e8d3'].tableData[0]['c77b4360f2fb4793b1898720103ef70e'];
                let projectId = this.parentFormData[0].values['e813309b96dd49f0b0ea30b507c5e8d3'].tableData[0]['id'];// 通过ID进行唯一判断，项目名称会有重复现象
                searchObj.projectId = this.parentFormData[0].values['e813309b96dd49f0b0ea30b507c5e8d3'].tableData[0]['id'];
                searchObj.conditionValue = this.parentFormData[0].values['e813309b96dd49f0b0ea30b507c5e8d3'].tableData[0]['id'];
                searchObj.searchFieldId = '3e5789e7e78845959731b8dbccac7882-link';
                let projectNameSearch = {
                    'id': '3e5789e7e78845959731b8dbccac7882',
                    'type': 'link',
                    'name': '项目名称',
                    'icon': '&#xe654;',
                    'formField': '3e5789e7e78845959731b8dbccac7882',
                    'formId': formId,
                    'operateType': 2,
                    'modelId': modelId,
                    'isView': true,
                    'conditionValue': projectId,
                    'modelName': '房地产个人绩效明细',
                    'searchFieldId': '3e5789e7e78845959731b8dbccac7882-link'
                };
                searchCondition.push(projectNameSearch);
            } else if (formId === '9ee70152560a4dce9da723777ddfa560') { // 资产个人绩效明细
                // let projectName = this.parentFormData[0].values['70289cc3f7fb470094a737b9a05d86c3'].tableData[0]['49f320b436274af2a10f31ff97525792'];
                let projectId = this.parentFormData[0].values['70289cc3f7fb470094a737b9a05d86c3'].tableData[0]['id'];// 通过ID进行唯一判断，项目名称会有重复现象
                searchObj.projectId = this.parentFormData[0].values['70289cc3f7fb470094a737b9a05d86c3'].tableData[0]['id'];
                searchObj.conditionValue = this.parentFormData[0].values['70289cc3f7fb470094a737b9a05d86c3'].tableData[0]['id'];
                searchObj.searchFieldId = '3e5789e7e78845959731b8dbccac7882-link';
                let projectNameSearch = {
                    'id': 'ebfcaa899f1943d98f68814eae6d8c39',
                    'type': 'link',
                    'name': '项目名称',
                    'icon': '&#xe654;',
                    'formField': 'ebfcaa899f1943d98f68814eae6d8c39',
                    'formId': formId,
                    'operateType': 2,
                    'modelId': modelId,
                    'isView': true,
                    'conditionValue': projectId,
                    'modelName': '资产个人绩效明细',
                    'searchFieldId': 'ebfcaa899f1943d98f68814eae6d8c39-link'
                };
                searchCondition.push(projectNameSearch);
            } else if (formId === '822a1c99d5164875aa5257ee6fd88150') { // 工程咨询个人绩效明细
                // let projectName = this.parentFormData[0].values['cf30b552e7bc4798a3ed827dea0b2252'].tableData[0]['c554cc6c17c148d7884bcd15bbd41f88'];
                let projectId = this.parentFormData[0].values['cf30b552e7bc4798a3ed827dea0b2252'].tableData[0]['id'];// 通过ID进行唯一判断，项目名称会有重复现象
                searchObj.projectId = this.parentFormData[0].values['cf30b552e7bc4798a3ed827dea0b2252'].tableData[0]['id'];
                searchObj.conditionValue = this.parentFormData[0].values['cf30b552e7bc4798a3ed827dea0b2252'].tableData[0]['id'];
                searchObj.searchFieldId = '3e5789e7e78845959731b8dbccac7882-link';
                let projectNameSearch = {
                    'id': 'cbbb0e48e632424aa49a9630063afe23',
                    'type': 'link',
                    'name': '项目名称',
                    'icon': '&#xe654;',
                    'formField': 'cbbb0e48e632424aa49a9630063afe23',
                    'formId': formId,
                    'operateType': 2,
                    'modelId': modelId,
                    'isView': true,
                    'conditionValue': projectId,
                    'modelName': '工程咨询个人绩效明细',
                    'searchFieldId': 'cbbb0e48e632424aa49a9630063afe23-link'
                };
                searchCondition.push(projectNameSearch);
            }
            let search = JSON.stringify(searchObj);
            await updRPARuleData({ formId: formId, search: search });// 生成绩效
            if (searchConditionArray && searchConditionArray.length > 0) {
                searchCondition = searchConditionArray;
                searchCondition.push(curItem);
            } else {
                searchCondition.push(curItem);
            }
            let param = {
                formId: formId,
                isFilterDuplicateData: false,
                isShowProcess: false,
                modelId: modelId,
                name: '',
                searchCondition: searchCondition,
                selectedApprovalStatus: '',
                selectedFields: '',
                selectedMonthStr: '',
                notIds: notIds,
                isMainSonForm: true
            };
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: 0,
                pageSize: 10000
            }, param));
            if (formData && formData.otherData && formData.otherData.searchCondition) {
                this.conditionFields = JSON.parse(formData.otherData.searchCondition);
            }
            if (formData.data) {
                let tableDatas = [];
                let idsArry = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                    idsArry.push(jsonObj.id);
                });
                this.popQuoteMoreIds = idsArry.join(',');
                if (this.popQuoteMoreIds) {
                    let idArray = this.popQuoteMoreIds.split(',');
                    for (let i = 0; i < idArray.length; i++) {
                        let temDataId = idArray[i];
                        tableDatas.forEach(element => {
                            if (element.id === temDataId) {
                                let res = this.pageData.find(obj => obj.id === temDataId);
                                if (!res) {
                                    this.pageData.push(element);
                                    let formValues = element.formValues;
                                    if (formValues) {
                                        let formValuesObj = JSON.parse(formValues);
                                        delete element.formValues;
                                        formValuesObj.values = element;
                                        // delete formValuesObj.attributes;
                                        let curItem = {
                                            formId: this.selectedModel.formId,
                                            modelId: this.selectedModel.id,
                                            forms: [
                                                formValuesObj
                                                // {values: element, formId: this.selectedModel.formId}
                                            ]
                                        };
                                        this.tempFormData.push(curItem);
                                    }
                                }
                            }
                        });
                        loading.close();
                    }
                }
                // if (this.popQuotePageData.length === 0) { // 防止新增了数据后。切换tab页签，刷新掉。
                //     this.popQuotePageData = tableDatas;
                // }
            }
            // if (formData.otherData.tableColumns) {
            //     this.popQuoteTableColumns = [];
            //     let _tableColumns = formData.otherData.tableColumns;
            //     this.allTableColumns = cloneDeep(_tableColumns);
            //     _tableColumns.forEach(item => {
            //         if (item.type !== 'divider') { // 隐藏分割线
            //             this.popQuoteTableColumns.push(item);
            //         }
            //     });
            // }
            // if (formData.otherData.fieldsList) {
            //     this.popQuoteFieldsList = formData.otherData.fieldsList;
            // }
            // this.subformTableColumns = formData.otherData.subformTableColumns;
            // // 如果是初次查询，需要获取isApprovalForm值，否则按照状态查询，则不需要重新赋值
            // if (this.isInit) {
            //     this.isApprovalForm = formData.otherData.isApprovalForm;
            // }
            // if (formData.otherData.approvalList) {
            //     this.approvalList = formData.otherData.approvalList;
            // }
            // this.isShowDown = formData.otherData.isShowDown;
            // if (this.$refs.popQuoteDynamicTable) {
            //     this.$refs.popQuoteDynamicTable.setMergeSpanArr(this.popQuotePageData);
            // }
            // this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            // this.popQuotePage = {
            //     currentPage: formData.currentPage,
            //     pageSize: formData.pageSize,
            //     totalPageNum: formData.totalPageNum
            // };
            this.tableLoading = false;
            // 是否要显示合计行
            // this.filterSumTableColumns();
            // this.popQuoteFormList = true;
        },
        removeQuoteFormData () {
            let removeArray = this.moreIds.split(',');
            let cacheArray = this.popQuoteMoreIds.slice(',');
            let popQuoteMoreIdsArray = [];
            for (let i = 0; i < removeArray.length; i++) {
                // this.tempFormData
                // this.pageData
                // this.popQuoteMoreIds
                let removeArrayItem = removeArray[i];
                for (let i1 = 0; i1 < this.tempFormData.length; i1++) {
                    let curItem = this.tempFormData[i1];
                    let curItemId = curItem.forms[0].values.id;
                    if (curItemId === removeArrayItem) {
                        this.tempFormData.splice(i1, 1);
                    }
                }
                for (let i2 = 0; i2 < this.pageData.length; i2++) {
                    let curItem = this.pageData[i2];
                    if (curItem.id === removeArrayItem) {
                        this.pageData.splice(i2, 1);
                    }
                }

                for (let i3 = 0; i3 < cacheArray.length; i3++) {
                    let curItem = cacheArray[i3];
                    if (curItem !== removeArrayItem) {
                        popQuoteMoreIdsArray.push(curItem);
                    }
                }
            }
            this.popQuoteMoreIds = popQuoteMoreIdsArray.join(',');
            this.$emit('refTempFormData', this.tempFormData);
            // console.log(this.moreIds);
            // console.log(this.pageData);
            // let data = cloneDeep(this.tempFormData);
            // this.$emit('refTempFormData', data);
        },
        getTempData () {
            return this.tempFormData;
        }
    }
};
</script>

<style lang="less">
.relate-model-FormList {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .el-button--small {
        padding: 8px 8px;
    }

    .el-collapse-item__wrap {
        padding: 0 20px;
    }

    .el-collapse {
        width: 100%;
    }

    .el-form {
        width: 95%;
    }

    .model-btns {
        height: 80px;
        padding: 0 10px 0 0;
    }

    .model-desc {
        .el-card__body {
            margin-top: -26px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .comments {
        width: 300px;
    }

    .btn-style {
        margin-top: 10px;
        padding-left: 5px;
        margin-left: 5px;
    }

    .checkBox-style {
        margin-left: 5px;

        .el-checkbox__label {
            padding-left: 5px;
        }
    }

    .report-tree-dialog {
        width: 800px;
        min-width: 600px;
        height: 800px;

    }
    .model-content{
        .content-left{
            padding-top: 2px;
        }
    }
}

.business-report-tree {
    .report-tree-dialog {
        .el-dialog__body {
            height: ~'calc(100% - 16vh)';
            margin-top: -6vh;
        }
    }
}

// .popEditModelDetail {
//     .el-dialog__body {
//         padding: 5px 30px 0px 0px;
//         color: #606266;
//         font-size: 14px;
//         word-break: break-all;
//         height: calc(100% - 8vh);
//     }
// }

.search-box {
    .element-editor {
        height: 60vh;
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/RelateFormList.vue